// extracted by mini-css-extract-plugin
export var newsHeader = "newstemplate-module--news-header--JwYKg";
export var newsImageWrapper = "newstemplate-module--news-image-wrapper--C8rlw";
export var newsText = "newstemplate-module--news-text--qG8HA";
export var newsWrapper = "newstemplate-module--news-wrapper--viLlx";